// Shared Leaflet tile layer config for every map in the app (Geospatial Overview,
// Infrastructure facility map, Executive regional map).
//
// CARTO retired anonymous access to its raster basemaps (dark_all / voyager) in 2023 —
// without a key the tiles render an "API KEY REQUIRED" watermark instead of the map.
// Get a free key (up to 5M tile loads/month, no card required) at
// https://carto.com/basemaps/apikey/ and set REACT_APP_CARTO_API_KEY in .env.local.
const CARTO_KEY = process.env.REACT_APP_CARTO_API_KEY || '';

const withKey = (url) => (CARTO_KEY ? `${url}?key=${CARTO_KEY}` : url);

export const hasCartoKey = Boolean(CARTO_KEY);

const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';

// "Voyager" is CARTO's full-colour style — roads, place labels, parks, buildings —
// the closest free equivalent to Google Maps' default look.
export const MAP_TILE_LAYERS = {
  light: {
    url: withKey('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'),
    attribution: OSM_ATTRIBUTION,
    label: 'Light',
  },
  dark: {
    url: withKey('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'),
    attribution: OSM_ATTRIBUTION,
    label: 'Dark',
  },
  satellite: {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '&copy; Esri, Maxar, Earthstar Geographics',
    label: 'Satellite',
  },
};

export function getMapTile(theme) {
  return MAP_TILE_LAYERS[theme] || MAP_TILE_LAYERS.light;
}
